/* stylelint-disable selector-class-pattern */
import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Caption = styled.div({
    flex: "1 1 100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "block",
    marginRight: 10,
});

export const RenameLink = styled.div({
    flex: "1 0 130px",
    display: "none",
});

export const DeleteLink = styled.div({
    flex: "1 0 80px",
    display: "none",
});

export const ContainerText = styled.div<{ highlighted?: boolean }>(props => ({
    lineHeight: theme(props).reactUISizes.input.height.css(),
    padding: theme(props).size([
        0.5,
        theme(props).reactUISizes.modal.rightPadding.css(),
        0.5,
        theme(props).reactUISizes.modal.leftPadding.css(),
    ]),
    display: "flex",
    backgroundColor: props.highlighted ? props.theme.candy.semanticColors.warning.backgroundColor : undefined,

    ":hover": {
        cursor: "pointer",
        backgroundColor: props.theme.candy.lists.items.accentLow.backgroundColor,

        [`${RenameLink}`]: {
            display: "inherit",
        },

        [`${DeleteLink}`]: {
            display: "inherit",
        },
    },
}));

export const TemplateDelete = styled.div(props => ({
    lineHeight: theme(props).reactUISizes.input.height.css(),
    backgroundColor: theme(props).semanticColors.warning.backgroundColor,
    padding: theme(props).size([
        0.5,
        theme(props).reactUISizes.modal.rightPadding.css(),
        0.5,
        theme(props).reactUISizes.modal.leftPadding.css(),
    ]),
}));

export const TemplateDeleteText = styled.span({
    marginRight: 20,
});

export const LoadedText = styled.div({
    wordWrap: "break-word",
    width: "100%",
});
